module.exports = __webpack_public_path__ + "img/Eddie Nketiah.87140885.png";